import { useNodeDelete, useNodeGetAll, useNodeUpdate } from "@/lib/api/node"
import { Node } from "@/components/node/Node.tsx"
import { LoadingSpinner } from "@/components/molecules/LoadingSpinner"
import { ModalCenter } from "@/components/atoms/ModalCenter"
import { useDisclosure } from "@mantine/hooks"
import { NodeSchema, Node as NodeType } from "@/lib/types/node.ts";
import { useState } from "react"
import { notifications } from "@mantine/notifications"
import { NodeForm } from "@/components/node/NodeForm"
import { DeleteConfirm } from "@/components/molecules/DeleteConfirm"

export const NodesOverview = () => {
  const [openedForm, { open: openForm, close: closeForm }] = useDisclosure()
  const [openedDelete, { open: openDelete, close: closeDelete }] = useDisclosure()

  const [selected, setSelected] = useState<NodeType | undefined>()
  const [toDelete, setToDelete] = useState<NodeType | undefined>()

  const nodeUpdate = useNodeUpdate()
  const nodeDelete = useNodeDelete()

  const { data: nodes, isLoading } = useNodeGetAll()

  if (isLoading) return <LoadingSpinner />

  const handleEdit = (node: NodeType) => {
    setSelected(node)
    openForm()
  }

  const handleSubmit = (node: NodeSchema) => {
    nodeUpdate.mutate(node, {
      onSuccess: () => notifications.show({ variant: "success", message: "Node geupdate" }),
      onSettled: () => {
        closeForm()
        setSelected(undefined)
      }
    });
  }

  const handleDeleteInit = (node: NodeType) => {
    setToDelete(node)
    openDelete()
  }

  const handleDelete = () => {
    if (!toDelete) return

    nodeDelete.mutate(toDelete, {
      onSuccess: () => notifications.show({ variant: "success", message: "Node verwijderd" }),
      onSettled: () => {
        setToDelete(undefined)
        closeDelete()
      }
    })
  }

  return (
    <>
      <div className="grid xl:grid-cols-2 gap-8">
        {nodes?.map(n => (
          <Node key={n.id} node={n} onEdit={handleEdit} onDelete={handleDeleteInit} />
        ))}
      </div>
      <ModalCenter
        opened={openedForm}
        onClose={closeForm}
        title="Edit node"
      >
        <NodeForm node={selected} close={closeForm} onSubmit={handleSubmit} />
      </ModalCenter>
      <DeleteConfirm
        opened={openedDelete}
        onClose={closeDelete}
        modalTitle={toDelete?.name ?? ""}
        title="Are you sure you want to delete it?"
        onDelete={handleDelete}
      />
    </>
  )
}
